import AdminProfile from "./pages/admin-profile";

const ProfileRoutes = [
  {
    path: "/profile",
    element: <AdminProfile />,
  },
];

export default ProfileRoutes;
